import _ from "lodash";
import React, { Component } from "react";
import { connect } from "react-redux";
import { InfoBar } from "ctia-ui";
import {
  getStatusTitle,
  getRequestVendor,
  isExisted
} from "helpers/RequestHelper";

class OtaInfoBar extends Component {
  state = {
    status: "",
    vendor: "",
    modelName: "",
    hwVersion: "",
    swVersion: ""
  };

  componentDidMount() {
    this.updateRequestInfo();
  }

  updateRequestInfo = () => {
    const { request, user } = this.props;
    const status = isExisted(request) ? getStatusTitle(request.status) : null;
    const vendor = getRequestVendor(request, user);
    const modelName = isExisted(request)
      ? request.modelName
      : request.existedModel;
    const hwVersion = user.isStaff ? request.hwVersion : null;
    const swVersion = user.isStaff ? request.swVersion : null;

    this.setState({ status, vendor, modelName, hwVersion, swVersion });
  };

  componentDidUpdate(prevProps) {
    const { request } = this.props;

    // TODO: might need when test plans will be added later
    // if (wizard && wizard.step !== prevProps.wizard.step) {
    //   this.updateRequestInfo();
    // }

    if (request && request.status !== prevProps.request.status) {
      this.updateRequestInfo();
    }
  }

  getValues = () => {
    const { status, vendor, modelName, hwVersion, swVersion } = this.state;
    const reqDataInfo = [
      {
        key: "Status",
        value: status
      },
      {
        key: "Vendor",
        value: vendor
      },
      {
        key: "Model Name/Number",
        value: modelName
      },
      {
        key: "HW Version",
        value: hwVersion
      },
      {
        key: "SW Version",
        value: swVersion
      }
    ];

    // remove fields with no values:
    return _.filter(reqDataInfo, field => !_.isNull(field.value));
  };

  render() {
    return <InfoBar show={true} data={this.getValues()} />;
  }
}

function mapStateToProps({ request, user }) {
  return { request, user };
}

export default connect(mapStateToProps)(OtaInfoBar);
